<script setup>
/**
 * @fileoverview Static (non-interactive) SVG drawing of a pattern: grout
 * background, 3/16" joints, and each tile filled from `fills` or left
 * unpainted. Used for the Step 1 thumbnails and the spec sheet.
 *
 * @component
 */
import { computed } from 'vue';
import { GROUT_WIDTH_IN, UNPAINTED_FILL, UNPAINTED_STROKE } from '../utils/patternData.js';

const props = defineProps({
    pattern: { type: Object, required: true },
    /** Tile id → hex; tiles not listed are drawn unpainted */
    fills: { type: Object, default: () => ({}) },
    groutHex: { type: String, default: '#EBE5DA' },
    /** Sheets per side */
    repeat: { type: Number, default: 1 },
});

const half = GROUT_WIDTH_IN / 2;

const offsets = computed(() => {
    const out = [];
    for (let j = 0; j < props.repeat; j++) {
        for (let i = 0; i < props.repeat; i++) {
            out.push({ x: i * props.pattern.width, y: j * props.pattern.height });
        }
    }
    return out;
});
</script>

<template>
    <svg
        :viewBox="`0 0 ${props.pattern.width * props.repeat} ${props.pattern.height * props.repeat}`"
        preserveAspectRatio="xMidYMid meet"
    >
        <rect
            :width="props.pattern.width * props.repeat"
            :height="props.pattern.height * props.repeat"
            :fill="props.groutHex"
        />
        <g v-for="(o, i) in offsets" :key="i" :transform="`translate(${o.x} ${o.y})`">
            <rect
                v-for="t in props.pattern.tiles"
                :key="t.id"
                :x="t.x + half"
                :y="t.y + half"
                :width="t.w - GROUT_WIDTH_IN"
                :height="t.h - GROUT_WIDTH_IN"
                :fill="props.fills[t.id] || UNPAINTED_FILL"
                :stroke="props.fills[t.id] ? 'none' : UNPAINTED_STROKE"
                stroke-width="1"
                vector-effect="non-scaling-stroke"
            />
        </g>
    </svg>
</template>
